module.exports = __webpack_public_path__ + "img/四川天府新区雅悦幼儿园.2bf96576.jpg";